"use client";

import { Card, Col, Row, Select, Switch, Typography } from "antd";
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { getObjectAnalyser, getObjectAnalyserList } from "../Controller";
import ObjectChart from "./ObjectChart";

export default function ObjectAnalysis({ filters }) {
  const [objectData, setObjectData] = useState({ tags: [], objects_count: [] });
  const [objectOptions, setObjectOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [optionsLoading, setOptionsLoading] = useState(true);
  const [timeType, setTimeType] = useState("created");
  const [objectId, setObjectId] = useState(null);

  const fetchObjectAnalysis = async () => {
    if (!objectId) return; // Don't fetch if no objectId is selected
    setLoading(true);
    try {
      const result = await getObjectAnalyser({
        time_type: timeType,
        period: filters.period.toLowerCase(),
        interval: parseInt(filters.interval.split(" ")[0]),
        offices: filters.offices,
        objanalyser_id: objectId,
      });
      console.log("result", result);
      setObjectData({
        tags: result && result.tags ? result.tags : [],
        objects_count: result && result.objects_count ? result.objects_count : [],
      });
    } catch (err) {
      console.error(err);
      setObjectData({ tags: [], objects_count: [] });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchObjectAnalysis();
  }, [filters, timeType, objectId]);

  useEffect(() => {
    const fetchDropDownOptions = async () => {
      try {
        setOptionsLoading(true);
        const result = await getObjectAnalyserList();
        setObjectOptions(result || []);
        // Set the first object as default if options exist
        if (result && result.length > 0) {
          setObjectId(result[0].id);
        }
      } catch (err) {
        console.error(err);
        setObjectOptions([]);
      } finally {
        setOptionsLoading(false);
      }
    };
    fetchDropDownOptions();
  }, []);

  return (
    <Row gutter={[22, 10]}>
      <Col xs={24}>
        <Typography.Title style={{ fontSize: "21px", fontWeight: 500, marginBottom: 11 }}>Parameters Anaylysis</Typography.Title>
      </Col>

      {/* Left side switches */}
      <Col xs={24} md={8}>
        <Card style={{ height: "100%" }}>
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", height: "100%" }}>
            <Switch
              checkedChildren="Created"
              unCheckedChildren="Updated"
              style={{
                width: 90,
                margin: "40px 0",
                transform: "scale(1.2)", // Scales the entire switch
                transformOrigin: "left top",
              }}
              onChange={(checked) => setTimeType(checked ? "created" : "updated")}
              defaultChecked
            />

            <div>
              <Select
                value={objectId}
                onChange={(value) => setObjectId(value)}
                style={{ height: 36, borderRadius: 8, color: "#6b43b5", width: 200 }}
                placeholder="Select a Parameter"
                loading={optionsLoading}
              >
                {objectOptions &&
                  objectOptions.map((object, index) => (
                    <Select.Option key={index} value={object.id}>
                      {object.target_content_type}
                    </Select.Option>
                  ))}
              </Select>
            </div>
          </div>
        </Card>
      </Col>
      {/* Right side chart */}
      <Col xs={24} md={16}>
        {filters.offices && filters.offices.length === 0 ? (
          <Card style={{ height: 360 }}> Please, select at least one office.</Card>
        ) : (
          <ObjectChart objectData={objectData} objectId={objectId} loading={loading || optionsLoading || !objectId} />
        )}
      </Col>
    </Row>
  );
}
